.hueco {
  display: block;
  width: var(--_w, 100%);
  height: var(--_h, var(--fs-sm));
  border-radius: var(--r-xs);
  background: var(--surface-muted);
  position: relative;
  overflow: hidden;
}
.hueco[data-shape="circle"] {
  border-radius: var(--r-full);
}
.hueco::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, var(--surface-card), transparent);
  opacity: 0.7;
  animation: brillo 1.4s var(--ease-standard) infinite;
}
.lineas {
  display: flex;
  flex-direction: column;
  gap: var(--s-3);
  width: var(--_w, 100%);
}
.lineas .hueco {
  width: 100%;
}
.lineas .hueco[data-ultima] {
  width: 62%;
}
@keyframes brillo {
  to {
    transform: translateX(100%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .hueco::after {
    animation: none;
  }
}
